<template>
  <SmallCard icon="icn20_wallet" color="primary" class="my-finance-widget">
    <template #header-text>
      <div class="header-label">
        <span>{{ headerLabel }}</span>
      </div>
      <div class="header-text text-no-wrap">
        <span>{{ headerText }}</span>
      </div>
    </template>
    <template #header-row-content>
      <v-select
        v-model="selectedMonth"
        class="rounded-select pl-3 pr-3"
        dense
        color="secondary"
        :items="months"
        outlined
      />
    </template>
    <v-row class="d-flex justify-space-between mt-7">
      <v-col class="profit-block block">
        <div class="block-content">
          <span v-html="formatMoneyWithCurrencyStyled(profitSum)" />
        </div>
        <div class="block-label">
          <span>{{ profitLabel }}</span>
        </div>
      </v-col>
      <v-col class="investments-block block">
        <div class="block-content">
          <span v-html="formatMoneyWithCurrencyStyled(invSum)" />
        </div>
        <div class="block-label">
          <span>{{ investmentsLabel }}</span>
        </div>
      </v-col>
    </v-row>
  </SmallCard>
</template>

<script>
import SmallCard from "@/components/core/cards/SmallCard.vue";
import { formatMoneyWithCurrencyStyled } from "@/plugins/formatters";

export default {
  name: "MyFinanceWidget",
  components: {
    SmallCard,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    invSum: {
      type: Number,
      default: 6124,
    },
    profitSum: {
      type: Number,
      default: 156124.8,
    },
  },
  computed: {
    selectedMonth: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    months() {
      return new Array(12).fill().map((_, ind) => {
        return {
          value: ind,
          text: this.$t(`months[${ind}]`),
        };
      });
    },
    headerLabel() {
      return this.$t("widgets.myDeals.headerLabel");
    },
    headerText() {
      return this.$t("investments.myFinance");
    },
    profitLabel() {
      return this.$t("investments.profit");
    },

    investmentsLabel() {
      return this.$t("investments.investments");
    },
  },
  methods: { formatMoneyWithCurrencyStyled },
};
</script>

<style lang="scss" scoped>
$select-width: 145px;
.rounded-select {
  max-height: 40px;
  min-width: $select-width;
  max-width: 100%;
  flex: 1;

  &::v-deep {
    fieldset {
      border-radius: 50px;
      border: unset !important;
      background: rgba(255, 255, 255, 0.1) !important;
    }

    .v-icon {
      color: rgba(255, 255, 255, 0.3) !important;
    }

    .v-select__slot {
      .v-select__selection.v-select__selection--comma {
        font-weight: 600;
        font-size: 11px;
        line-height: 130%;
        color: var(--surface-background) !important;
      }
    }
  }
}

.my-finance-widget {
  .header {
    flex: 1;
    max-width: 100%;
  }

  .block {
    max-width: 50%;
    flex: 1;

    .block-label {
      white-space: nowrap;
      font-size: 11px;
      line-height: 1.3;
      margin-top: 8px;
    }

    .block-content {
      display: flex;
      flex-wrap: nowrap;
      font-weight: 600;
      font-size: 27px;
      line-height: 130%;
    }
  }

  .investments-block {
    max-width: $select-width;
  }
}
</style>
